import React, { useRef } from 'react';
import Logo from './Logo';
import './AuthShell.css';

const ICON = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true };
export const AUTH_ICONS = {
  mail: <svg {...ICON}><rect x="2.5" y="4.5" width="19" height="15" rx="2" /><path d="m21.5 7-9.5 6.5L2.5 7" /></svg>,
  lock: <svg {...ICON}><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>,
};

// Two-panel shell shared by "Log ind" and "Opret adgang": a dark brand panel
// on the left, the form on the right.
export default function AuthShell({ children }) {
  return (
    <div className="au">
      <div className="au-side">
        <span className="au-logo"><Logo size={30} /><span>nord<i>comply</i></span></span>
        <h2>Microsoft 365 viser problemet. <em>Vi dokumenterer beslutningen.</em></h2>
        <small>Dansk udviklet, dansk hosted</small>
      </div>
      <div className="au-main">
        <div className="au-box">{children}</div>
      </div>
    </div>
  );
}

export function AuthField({ label, icon, bad, children }) {
  return (
    <label className="au-field">
      <span>{label}</span>
      <div className={`au-in${bad ? ' au-bad' : ''}`}>
        {AUTH_ICONS[icon]}
        {children}
      </div>
    </label>
  );
}

// Six boxes for the authenticator code — moves on as you type, and a pasted
// code fills all six at once. `value` is always the plain digit string.
export function CodeInput({ value, onChange, disabled, bad, length = 6 }) {
  const refs = useRef([]);
  const digits = value.padEnd(length, ' ').slice(0, length).split('');

  function setAt(i, ch) {
    const next = digits.map((d, k) => (k === i ? ch : d)).join('').replace(/ /g, '');
    onChange(next);
  }

  function handleChange(i, e) {
    const ch = e.target.value.replace(/\D/g, '').slice(-1);
    if (!ch) return;
    setAt(i, ch);
    if (i < length - 1) refs.current[i + 1]?.focus();
  }

  function handleKeyDown(i, e) {
    if (e.key === 'Backspace') {
      e.preventDefault();
      if (digits[i].trim()) setAt(i, ' ');
      else if (i > 0) {
        setAt(i - 1, ' ');
        refs.current[i - 1]?.focus();
      }
    } else if (e.key === 'ArrowLeft' && i > 0) refs.current[i - 1]?.focus();
    else if (e.key === 'ArrowRight' && i < length - 1) refs.current[i + 1]?.focus();
  }

  function handlePaste(e) {
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, length);
    if (!pasted) return;
    e.preventDefault();
    onChange(pasted);
    refs.current[Math.min(pasted.length, length - 1)]?.focus();
  }

  return (
    <div className={`au-code${bad ? ' au-bad' : ''}`} onPaste={handlePaste}>
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => { refs.current[i] = el; }}
          value={d.trim()}
          onChange={(e) => handleChange(i, e)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onFocus={(e) => e.target.select()}
          inputMode="numeric"
          autoComplete={i === 0 ? 'one-time-code' : 'off'}
          maxLength={2}
          disabled={disabled}
          aria-label={`Ciffer ${i + 1} af ${length}`}
        />
      ))}
    </div>
  );
}
